import { render, staticRenderFns } from "./FmBreadcrumbItem.vue?vue&type=template&id=4a53bfdd&scoped=true&"
import script from "./FmBreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./FmBreadcrumbItem.vue?vue&type=script&lang=js&"
import style0 from "./FmBreadcrumbItem.vue?vue&type=style&index=0&id=4a53bfdd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53bfdd",
  null
  
)

export default component.exports